module.exports = __webpack_public_path__ + "static/media/standard_rendimiento.95d80af0.png";